// TODO:区分コード管理.xlsx参考

/**
 * F0001	取込ファイル区分
 */
export const e取込ファイル区分 = {
  矢崎ESTRA_デジタコCSV: "11",
  光英_デジタコCSV: "12",
  ETC_GET_CSV: "21",
  宇佐美_給油CSV: "31",
  ENEOS_給油CSV: "32",
  自社_給油CSV: "33",
  償却費CSV: "41",
  任意保険CSV: "42",
} as const

export type T取込ファイル区分名称 = keyof typeof e取込ファイル区分
export type T取込ファイル区分 = typeof e取込ファイル区分[T取込ファイル区分名称]
